import { CalendarItemUnion } from '@akin-home/calendar/combined';
import { isBefore } from 'date-fns';

interface Params {
  mode: 'edit' | 'create';

  item: CalendarItemUnion;
}

type Response =
  | {
      error: string;
    }
  | {
      valid: boolean;
    };

export const validateCalendarItemFormSubmission = ({
  item,
}: Params): Response => {
  if (!item.title?.length) {
    return {
      error: 'No title specified',
    };
  }

  if ('end' in item && isBefore(item.end, item.start)) {
    return {
      error: 'Start date must be before end date',
    };
  }

  return {
    valid: true,
  };
};
